<template>
		 <div id="iframe-container">
      <iframe :src="url"  scrolling="auto" frameborder="0" id="iframe"></iframe>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				url:'',
				isEntranceData:'',
				pageType:''
				
			}
		},
		mounted(){
			this.url=this.$route.query.url;
			if(this.$route.query.isEntranceData){
				this.isEntranceData=this.$route.query.isEntranceData;
			}
			if(this.$route.query.pageType){
				this.pageType=this.$route.query.pageType
			}
			this.insertPageAccessData()
			this.$commonApi.share();
		},
		methods:{
			insertPageAccessData() {
				var prevPage = "";
				if (this.pageType === "bookCharge") {
					prevPage = "充值页";
				} else if (this.pageType === "bookCity") {
					prevPage = "书城";
				} 
				var params = {
					pageName: '网页',
					pageRemark: '上级页面：'+prevPage,
					isEntranceData:this.isEntranceData
				}
				this.$api.insertPageAccessData(params).then(res => {
			
				})
			},
			
		}
	}
</script>

<style scoped>
#iframe-container,#iframe{
	height:100%;
	width:100%;
}
</style>



// WEBPACK FOOTER //
// src/view/bookWeb/index.vue